import { render, staticRenderFns } from "./VersionModal__Style#Drawer.vue?vue&type=template&id=4cff62ba&scoped=true&"
import script from "./VersionModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./VersionModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./VersionModal__Style#Drawer.vue?vue&type=style&index=0&id=4cff62ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cff62ba",
  null
  
)

export default component.exports